export default "__VITE_ASSET__CojA_7sC__"